import { Component, OnInit, Input, ViewChild, OnChanges, OnDestroy, HostListener, Renderer2 } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { getFirebaseBackend } from 'src/app/authUtils';
import { OldDataService } from 'src/app/core/services/old-data.service';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import Swal from 'sweetalert2';
import { Location } from '@angular/common';
import { Subscription } from 'rxjs';

import { AuthenticationService } from 'src/app/core/services/auth.service';
import { SelectedOptionsService } from 'src/app/services/selected-options/selected-options.service';
import { UtilsService } from 'src/app/services/utils/utils.service';
import { LeadService } from 'src/app/services/lead/lead.service';
import { CampaignsService } from 'src/app/services/campaigns/campaigns.service';
import { TITLES } from 'src/app/shared/constants';
import { UserService } from 'src/app/services/user/user.service';

@Component({
	selector: 'lead',
	templateUrl: './lead.component.html',
	styleUrls: ['./lead.component.scss'],
})
export class LeadComponent implements OnInit, OnChanges, OnDestroy {
	@Input() ID: number = 0;

	public user: any;
	public leadId: number;
	@ViewChild('modal_notes') modal_notes: NgbModal;

	public today: Date = new Date();

	public lead: any = null; //Aqui esta toda la info de la pantalla details
	public beforeReplacementStatus;
	public leadMsg: string = null;
	public leadLoading: boolean = true;
	public campaignId = 0;
	client_notes: any;
	messageError: string = '';
	messageSuccess: string = '';
	loadingSaveNote: boolean = false;
	client_input: boolean = false;

	public titles: any = [];

	public activeTab: string = 'details';

	public activeCampaigns: any = [];
	public activeCampaign: number = null;

	public from: string = '';

	public leadsChanges: any = [];
	public formData = {
		client_notes_area: '',
	};
	copyNotes = '';

	public confVmFullDate = null;
	public contactedFulldate = null;
	public remplacedFullDate = null;
	public dateCharged = null;

	public employeeId: string = '';

	public callSheetTab: string = 'details';
	public campaign_info = null;
	public camapignInfoLoading: boolean = false;

	public client: any = null;
	public leadNumber: number = 0;

	public isEnabled = false;
	//Back Options

	public searchCampaignId;
	public searchAgentLogin;
	public dateOf;
	public fromDate;
	public toDate;
	public toView;
	public backUrl;

	public user_id;

	public client_notes_display: boolean = false;
	public client_feedback_display: boolean = false;
	public reschedule_reason_display: boolean = false;
	public showRescheduleBtn: boolean = false;
	public triggerSubscription: Subscription;
	notes: any = [];

	fromCalendar = false;
	calendarAlias: string;
	calendarId: string;

	constructor(
		private router: Router,
		private dataService: OldDataService,
		private route: ActivatedRoute,
		public authenticationService: AuthenticationService,
		private modalService: NgbModal,
		private utils: UtilsService,
		private selectedOptions: SelectedOptionsService,
		private leadSrv: LeadService,
		private campaignSrv: CampaignsService,
		private renderer: Renderer2,
		private userSrv: UserService,
	) {
		// this.user = this.authenticationService.currentUserValue;
		this.user = getFirebaseBackend()?.getAuthenticatedUser();
		// console.log(this.user);
		this.leadId = parseInt(this.route.snapshot.paramMap.get('selectedLead'));
	}

	ngOnInit() {
		this.route.queryParams.subscribe((params) => {
			this.fromCalendar = params['from'] === 'calendar';
			this.calendarAlias = params['calendarAlias'];
			this.calendarId = params['calendarId'];

			if (this.fromCalendar) {
				this.renderer.addClass(document.body, 'hide-chrome');
			}
		});
		if (this.ID != 0) {
			this.leadId = this.ID;
		}

		this.getLeadById();
		this.getActiveCampaigns();
		this.get_customer_notes_bylead();
		this.titles = TITLES;
		this.triggerSubscription = this.selectedOptions.triggerBackButton.subscribe((data) => {
			// this.saveLead();
		});
	}

	ngOnChanges(): void {}

	ngOnDestroy() {
		this.triggerSubscription.unsubscribe();
		this.renderer.removeClass(document.body, 'hide-chrome');
	}

	@HostListener('window:popstate', ['$event'])
	onPopState(event: Event) {
		// this.backButton();
		history.pushState(null, '', window.location.href);
	}

	pad(n, width, z) {
		z = z || '0';
		n = n + '';
		return n.length >= width ? n : new Array(width - n.length + 1).join(z) + n;
	}

	getActiveCampaigns() {
		this.activeCampaigns = [];
		this.campaignSrv.getCampaignsForSelect('1').subscribe((data: any) => {
			this.activeCampaigns = data.body;
		});
	}

	getLeadById() {
		this.leadSrv.lead_detail(this.leadId).subscribe((data: any) => {
			this.lead = data.body;
			this.lead.new_qc_notes = '';
			this.beforeReplacementStatus = this.lead.replacement_status;
			this.lead.old_qc_notes = this.lead.qc_notes;
			this.campaignId = this.lead.campaign_id;
			if (this.lead.client_feedback != '' && this.lead.client_feedback != null) {
				this.client_feedback_display = true;
			}
			if (this.lead.reschedule_reason != '' && this.lead.reschedule_reason != null) {
				this.reschedule_reason_display = true;
			}

			if (this.lead.form_5500 === 'null' || this.lead.form_5500 === undefined) {
				this.lead.form_5500 = null;
			}

			if (this.lead.confirmation_voicemail_date != null) {
				this.lead.confirmation_voicemail_date = this.utils.phptoNgbDate(this.lead.confirmation_voicemail_date);
			}

			if (this.lead.contacted_date != null) {
				this.lead.contacted_date = this.utils.phptoNgbDate(this.lead.contacted_date);
			}

			if (this.lead.remplaced_date != null) {
				this.lead.remplaced_date = this.utils.phptoNgbDate(this.lead.remplaced_date);
			}

			if (this.lead.date_charged != null) {
				this.lead.date_charged = this.utils.phptoNgbDate(this.lead.date_charged);
			}

			this.leadLoading = false;
			this.getDispoLogNotes();
		});
	}

	get_customer_notes_bylead() {
		this.messageError = '';
		this.leadSrv.get_customer_notes_bylead(this.leadId).subscribe((data) => {
			if (data) {
				this.client_notes = data.body;
			} else {
				this.messageError = 'Endpoint Failed, please check with support area';
			}
		});
	}

	backToLeads() {
		this.router.navigate(['/admin-portal']);
	}

	addZerosDate(number) {
		number += 1;
		if (number < 10) {
			return '0' + number.toString();
		} else {
			return number.toString();
		}
	}

	getCallSheet() {
		this.campaign_info = null;
		this.activeTab = 'call_sheet';
		this.camapignInfoLoading = true;

		this.campaignSrv.getCampaignCallSheet(this.campaignId).subscribe((data: any) => {
			this.campaign_info = data.body[0];
			this.camapignInfoLoading = false;
		});
	}

	public Time24To12(date: String, time: String) {
		var FormatTime = new Date(date + ' ' + time);
		var infoTime;
		infoTime = FormatTime.toLocaleString('en-US', { hour: 'numeric', minute: 'numeric', hour12: true });
		return infoTime;
	}

	copyMessage(val: string) {
		const selBox = document.createElement('textarea');
		selBox.style.position = 'fixed';
		selBox.style.left = '0';
		selBox.style.top = '0';
		selBox.style.opacity = '0';
		selBox.value = val;
		document.body.appendChild(selBox);
		selBox.focus();
		selBox.select();
		document.execCommand('copy');
		document.body.removeChild(selBox);
	}

	setAndBack(from) {
		switch (from) {
			case 'qc':
				this.searchAgentLogin = this.route.snapshot.queryParams['searchAgentLogin'];
				this.searchCampaignId = this.route.snapshot.queryParams['searchCampaignId'];

				this.dateOf = this.route.snapshot.queryParams['dateOf'];
				this.fromDate = this.route.snapshot.queryParams['fromDate'];
				this.toDate = this.route.snapshot.queryParams['toDate'];
				this.toView = this.route.snapshot.queryParams['toView'];
				break;
			case 'acc_review':
				this.fromDate = this.route.snapshot.queryParams['fromDate'];
				this.toDate = this.route.snapshot.queryParams['toDate'];
				this.user_id = this.route.snapshot.queryParams['user_id'];
				this.backUrl = 'user-client-edit';
				break;

			default:
				break;
		}
	}

	showRescheduleButton() {
		const today = new Date().getTime();
		const apptDate = new Date(this.lead.date_generated);
		let twoDaysLater = new Date(this.lead.date_generated);
		twoDaysLater.setDate(twoDaysLater.getDate() + 2);

		if (today > apptDate.getTime()) {
			if (today < twoDaysLater.getTime()) {
				this.showRescheduleBtn = true;
			}
		}
	}

	submitNotes() {
		this.loadingSaveNote = true;
		if (this.formData.client_notes_area != '') {
			this.leadSrv.saveClientNotesByLead(this.leadId, this.formData.client_notes_area, this.client_input).subscribe(
				(data) => {
					if (data.success) {
						this.messageSuccess = 'Notes saved successfully';
						this.get_customer_notes_bylead();
					} else {
						this.messageError = "The data doesn't save, please check with support area";
					}
					this.loadingSaveNote = false;
					this.formData.client_notes_area = '';
				},
				() => {
					this.loadingSaveNote = false;
				},
			);
		} else {
			Swal.fire({
				title: 'Please write some comments to save',
				icon: 'warning',
				confirmButtonText: 'ok',
			});

			this.loadingSaveNote = false;
		}
	}

	getDispoLogNotes() {
		this.leadSrv.getDispoLogNotes(this.lead.prospect_id).subscribe((data: any) => {
			this.notes = data.body;
			this.copyNotes = this.notes[0].notes;
		});
	}

	onPhoneClick(phone: string): void {
		this.userSrv.saveAction('Start Call');

		this.userSrv.startCall({
			campaign: this.lead?.campaign_id,
			source_view: 'lead',
			primary_phone: phone,
			first_name: this.lead?.first_name,
			last_name: this.lead?.last_name,
		});
	}

	backToCalendar() {
		this.router.navigate(['/calendar', this.calendarAlias, this.calendarId], {
			queryParams: { from: 'campaign' },
		});
	}
}
